.search {
  width: 100%;
  max-width: 1600px;
  min-height: 288px;
  margin-inline: auto;
  margin-top: var(--pgm-sys-spacing-10);
  padding-block: var(--pgm-sys-spacing-6);
  padding-inline: var(--pgm-sys-spacing-8);
  border-radius: var(--pgm-sys-spacing-4);
  background-color: var(--pgm-sys-color-surface-container-low);
  color: var(--pgm-sys-color-on-surface);
}

.searchCollapsed {
  min-height: 0;
  padding-block: var(--pgm-sys-spacing-3);
}

.headingContainer {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--pgm-sys-spacing-4);
  margin-bottom: var(--pgm-sys-spacing-6);
}

.headingContainerCollapsed {
  align-items: center;
  margin-bottom: var(--pgm-sys-spacing-0);
}

.headingText {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  min-width: 0;
}

.headingTitle,
.headingDescription {
  margin: var(--pgm-sys-spacing-0);
}

.headingDescription {
  color: var(--pgm-sys-color-on-surface-variant);
}

.collapseButton {
  flex-shrink: 0;
}

.collapseIcon,
.searchIcon {
  width: var(--pgm-sys-spacing-5);
  height: var(--pgm-sys-spacing-5);
  font-size: var(--pgm-sys-spacing-5);
  line-height: var(--pgm-sys-spacing-5);
}

.searchIcon {
  font-variation-settings:
    "FILL" 0,
    "wght" 400,
    "GRAD" 0,
    "opsz" 20;
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  width: 100%;
  background-color: transparent;
}

.formInput {
  width: 100%;
  min-height: 56px;
}

.inputField {
  flex: 1 1 0;
  width: 100%;
  min-width: 0;
  min-height: 56px;
}

.inputFieldWithMessage {
  min-height: calc(56px + var(--pgm-sys-spacing-1) + var(--pgm-sys-typescale-body-small-line-height, var(--pgm-sys-spacing-4)));
}

.inputContainer,
.submitContainer {
  display: flex;
  gap: var(--pgm-sys-spacing-6);
}

.submitContainer {
  align-items: center;
  justify-content: space-between;
}

.infoRefis {
  margin-bottom: var(--pgm-sys-spacing-0);
  color: var(--pgm-sys-color-on-surface);
}

.initialMessage {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--pgm-sys-spacing-6);
  width: 100%;
  max-width: 1600px;
  min-height: 152px;
  margin: var(--pgm-sys-spacing-6) auto var(--pgm-sys-spacing-16);
  padding-block: var(--pgm-sys-spacing-10);
  text-align: center;
}

.initialMessageIcon {
  width: var(--pgm-sys-spacing-16);
  height: var(--pgm-sys-spacing-16);
  color: var(--pgm-sys-color-outline);
  font-size: var(--pgm-sys-spacing-16);
  line-height: var(--pgm-sys-spacing-16);
}

.initialMessageText {
  color: var(--pgm-sys-color-on-surface-variant);
}

.initialMessageText p {
  margin: var(--pgm-sys-spacing-0);
}

.resultsContainer {
  width: 100%;
  max-width: 1600px;
  margin: var(--pgm-sys-spacing-6) auto var(--pgm-sys-spacing-16);
  color: var(--pgm-sys-color-on-surface);
}

.resultsContainer:empty {
  display: none;
}

.loadingState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--pgm-sys-spacing-4);
  min-height: clamp(240px, 45vh, 480px);
  color: var(--pgm-sys-color-on-surface-variant);
  text-align: center;
}

.loadingIndicator {
  width: var(--pgm-sys-spacing-12);
  height: var(--pgm-sys-spacing-12);
  box-sizing: border-box;
  border: var(--pgm-sys-spacing-1) solid var(--pgm-sys-color-surface-container-highest);
  border-top-color: var(--pgm-sys-color-primary);
  border-radius: 50%;
  animation: loadingRotation 800ms linear infinite;
}

.loadingText {
  margin: var(--pgm-sys-spacing-0);
  color: var(--pgm-sys-color-on-surface-variant);
}

@keyframes loadingRotation {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .loadingIndicator {
    animation-duration: 1600ms;
  }
}

.resultsHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--pgm-sys-spacing-6);
  margin-bottom: var(--pgm-sys-spacing-4);
}

.resultSummary {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
}

.contributorName,
.contributorLabel {
  color: var(--pgm-sys-color-on-surface);
}

.contributorName {
  text-transform: uppercase;
}

.contributorValue {
  color: var(--pgm-sys-color-on-surface-variant);
}

.contributorTotals {
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-6);
}

.resultsMessages {
  align-items: flex-end;
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  min-width: 0;
}

.paymentError {
  align-items: center;
  background-color: var(--pgm-sys-color-warning-container);
  border-radius: var(--pgm-sys-spacing-1);
  color: var(--pgm-sys-color-on-warning-container);
  display: flex;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-3);
}

.paymentErrorIcon {
  flex: 0 0 var(--pgm-sys-spacing-4);
  font-size: var(--pgm-sys-spacing-4);
  height: var(--pgm-sys-spacing-4);
  line-height: var(--pgm-sys-spacing-4);
  width: var(--pgm-sys-spacing-4);
}

.search :global(.form-group) {
  margin-bottom: var(--pgm-sys-spacing-0);
}

.otherDebts {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: var(--pgm-sys-spacing-2);
}

.otherDebtsMessage {
  display: flex;
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
  box-sizing: border-box;
  padding-block: var(--pgm-sys-spacing-3);
  padding-inline: var(--pgm-sys-spacing-3);
  border-radius: var(--pgm-sys-spacing-2);
  background-color: var(--pgm-sys-color-info-container);
  color: var(--pgm-sys-color-on-info-container);
}

.otherDebtsIcon {
  flex: 0 0 var(--pgm-sys-spacing-5);
  width: var(--pgm-sys-spacing-5);
  height: var(--pgm-sys-spacing-5);
  font-size: var(--pgm-sys-spacing-5);
  line-height: var(--pgm-sys-spacing-5);
}

.tabsContentItemsConsultDebts,
.containerTabsConsultDebts {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
}

.tabsContentItemsConsultDebts {
  margin: var(--pgm-sys-spacing-0);
}

.carouselVisibilityConsultDebts {
  width: 100%;
  overflow-x: auto;
}

.tipoReceita {
  display: block;
  width: auto;
  max-height: var(--pgm-sys-spacing-12);
}

.tipoReceitaMobile,
.arrowLeftConsultDebts,
.arrowRightConsultDebts {
  display: none;
}

.tabTipoReceitaConsultDebts,
.tabTipoReceitaMobileConsultDebts {
  position: relative;
  height: var(--pgm-sys-spacing-12);
  max-height: var(--pgm-sys-spacing-12);
  box-sizing: border-box;
  margin: var(--pgm-sys-spacing-0);
  padding-block: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-0);
  padding-inline: var(--pgm-sys-spacing-4);
  overflow: hidden;
  border-radius: 0;
  background: transparent;
  color: var(--pgm-sys-color-on-surface-variant);
  font-family: var(--pgm-sys-typescale-title-small-font);
  font-size: var(--pgm-sys-typescale-title-small-size);
  font-style: normal;
  font-weight: var(--pgm-sys-typescale-title-small-weight);
  line-height: var(--pgm-sys-typescale-title-small-line-height);
  letter-spacing: var(--pgm-sys-typescale-title-small-tracking);
  cursor: pointer;
  opacity: 1;
  text-overflow: ellipsis;
}

.tabTipoReceitaConsultDebts:hover,
.tabTipoReceitaMobileConsultDebts:hover {
  background-color: color-mix(
    in srgb,
    var(--pgm-sys-color-on-surface) 8%,
    transparent
  );
}

.tabTipoReceitaSelectedConsultDebts {
  color: var(--pgm-sys-color-on-surface);
}

.recipTitle {
  width: auto;
  margin: var(--pgm-sys-spacing-0);
  overflow: hidden;
  font: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selectedTabConsultDebts {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  width: auto;
  height: 2px;
  margin: var(--pgm-sys-spacing-0);
  background-color: var(--pgm-sys-color-primary);
}

.contentTypeConsultDebts {
  position: relative;
  width: 100%;
  margin: var(--pgm-sys-spacing-0);
  border-radius: 0;
  background: transparent;
}

@media (max-width: 768px) {
  .search,
  .resultsContainer {
    max-width: calc(100% - var(--pgm-sys-spacing-8));
  }

  .inputContainer,
  .submitContainer,
  .contributorTotals {
    flex-direction: column;
  }

  .resultsHeader {
    align-items: stretch;
    flex-direction: column;
  }

  .resultsMessages {
    align-items: stretch;
  }

  .otherDebts {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .otherDebtsMessage {
    flex: 1 1 280px;
  }

  .arrowLeftConsultDebts,
  .arrowRightConsultDebts {
    display: grid;
    align-content: center;
    color: var(--pgm-sys-color-secondary);
    font-size: 30px;
  }

  .carouselVisibilityConsultDebts {
    height: 140px;
    overflow-x: hidden;
  }

  .tipoReceita {
    display: none;
  }

  .tipoReceitaMobile {
    display: grid;
    grid-template-columns: 201px;
    max-height: 75px;
    margin: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-0);
  }

  .tabTipoReceitaMobileConsultDebts {
    height: 130px;
    max-height: 130px;
    padding-block: var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-0);
    padding-inline: var(--pgm-sys-spacing-4);
    border-radius: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-2) 0 0;
  }
}
